var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.headerComponent,{tag:"Component",class:_vm.rootClass,attrs:{"show-on-mobile":_vm.showOnMobile,"with-navbar":_vm.withNavbar}})}
var staticRenderFns = []

export { render, staticRenderFns }